$mol_theme_demo $mol_example_large
	plugins /
		<= Theme $mol_theme_auto
	style *
		--mol_theme_hue <= hue_deg \
		--mol_theme_hue_spread <= hue_spread_deg \
	sub /
		<= Config $mol_row sub /
			<= Hue_field $mol_form_field
				name \Hue
				Content <= Hue $mol_number
					value? <=> hue? 240
					precision_change 15
			<= Hue_spread_field $mol_form_field
				name \Hue spread
				Content <= Hue_spread $mol_number
					value? <=> hue_spread? 90
					precision_change 15
			<= Lights_field $mol_form_field
				name \Lights
				Content <= Lights $mol_lights_toggle
		<= Scroll $mol_scroll sub /
			<= Cases $mol_theme_demo_case
				title \Current light
				inner /
					<= Base $mol_theme_demo_case theme \$mol_theme_base
					<= Current $mol_theme_demo_case theme \$mol_theme_current
					<= Special $mol_theme_demo_case theme \$mol_theme_special
					<= Accent $mol_theme_demo_case theme \$mol_theme_accent
	tags /
		\theme
		\skin
	aspects /
		\Type/Color

$mol_theme_demo_case $mol_view
	title <= theme \
	sub /
		<= Self $mol_list rows /
			<= Card1 $mol_list rows /
				<= Card2 $mol_row sub /
					<= Card2_text $mol_button_copy title <= title
				<= Card1_text $mol_button_copy title \	$mol_theme.card
			<= Back $mol_button_copy title \$mol_theme.back
			<= Line $mol_button_copy title \$mol_theme.line
			<= Text $mol_button_copy title \$mol_theme.text
			<= Field $mol_button_copy title \$mol_theme.field
			<= Shade $mol_button_copy title \$mol_theme.shade
			<= Focus $mol_button_copy title \$mol_theme.focus
			<= Control $mol_button_copy title \$mol_theme.control
			<= Hover $mol_button_copy title \$mol_theme.hover
			<= Current $mol_button_copy title \$mol_theme.curent
			<= Special $mol_button_copy title \$mol_theme.special
		^ inner 
	inner /
